import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { NotifyService } from '../../shared/services/notify.service';

/**
 * Guard บังคับว่าต้องมี active package ถึงเข้าหน้านี้ได้ — ใช้กับ `/owner/form` (สร้างประกาศ)
 * ถ้าไม่มี package → notify + redirect ไปหน้าซื้อแพ็กเกจ
 * (Back-end ก็เช็คซ้ำอีกชั้นใน OwnerAuctionController.Create → defense in depth)
 */
export const packageRequiredGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const notify = inject(NotifyService);

  const user = auth.currentUser();
  if (user?.hasActivePackage) return true;

  notify.notify({
    title: 'ยังไม่สามารถสร้างประกาศได้',
    detail: 'กรุณาซื้อแพ็กเกจก่อนจึงจะสร้างประกาศได้',
    variant: 'warning',
    icon: 'lock',
  });
  return router.createUrlTree(['/owner/packages']);
};
